// extracted by mini-css-extract-plugin
var _1 = "tjs-bottom-dock-chart__empty";
export { _1 as "empty" }
export default { "empty": _1 }
